import useApi from "./api";

// Transfer-specific API methods
export const useTransferApi = () => {
  const api = useApi(false);

  // Get transfer status by ID (for step-up auth polling)
  const getTransferStatus = async (transferId) => {
    try {
      const response = await api.get(`transfer/history/${transferId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching transfer status:", error);
      throw error;
    }
  };

  return {
    getTransferStatus,
  };
};